import {IDataSourceInfo} from '@app/views/databrowsing/model/attr-history-item';
import {IntegrationMode} from '@app/views/admin/application-settings/models/integration-mode.model';
import {DataSourceConfig, DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {environment} from '@env/environment';

export enum DataSourceType {
    DataAPI = 'DataAPI',
    EdFi = 'EdFi',
    EduTone = 'EduTone',
    OneRoster = 'OneRoster',
    PowerSchool = 'PowerSchool',
    SFTP = 'SFTP',
    Skyward = 'Skyward',
    CsvUpload = 'CsvUpload',
    Passport = 'Passport',
    Inow = 'Inow',
    Illuminates = 'Illuminates',
    Coursera = 'Coursera',
    LTI = 'LTI',
    Gg4lPassport = 'Gg4lPassport',
    Veracross = 'Veracross',
    LDAP = 'LDAP',
    GSuite = 'GSuite',
    OpenApply = 'OpenApply',
    ManageBac = 'ManageBac',
    Qwiklabs = 'Qwiklabs',
    GoogleClassroom = 'GoogleClassroom',
    Aeries = 'Aeries',
    Blackboard = 'Blackboard',
}

export const DATA_SOURCE_TYPE = {
    DataAPI: DataSourceType.DataAPI,
    EdFi: DataSourceType.EdFi,
    EduTone: DataSourceType.EduTone,
    OneRoster: DataSourceType.OneRoster,
    PowerSchool: DataSourceType.PowerSchool,
    SFTP: DataSourceType.SFTP,
    Skyward: DataSourceType.Skyward,
    CsvUpload: DataSourceType.CsvUpload,
    Passport: DataSourceType.Passport,
    Inow: DataSourceType.Inow,
    Illuminates: DataSourceType.Illuminates,
    Coursera: DataSourceType.Coursera,
    LTI: DataSourceType.LTI,
    Gg4lPassport: DataSourceType.Gg4lPassport,
    Veracross: DataSourceType.Veracross,
    LDAP: DataSourceType.LDAP,
    GSuite: DataSourceType.GSuite,
    OpenApply: DataSourceType.OpenApply,
    ManageBac: DataSourceType.ManageBac,
    Qwiklabs: DataSourceType.Qwiklabs,
    GoogleClassroom: DataSourceType.GoogleClassroom,
    Aeries: DataSourceType.Aeries,
    Blackboard: DataSourceType.Blackboard,
};

export const DataSourcePathMap = new Map([
    [DataSourceType.DataAPI, 'data-api'],
    [DataSourceType.EdFi, 'ed-fi'],
    [DataSourceType.EduTone, 'edutone'],
    [DataSourceType.OneRoster, 'one-roster'],
    [DataSourceType.PowerSchool, 'power-school'],
    [DataSourceType.Skyward, 'skyward'],
    [DataSourceType.SFTP, 'sftp'],
    [DataSourceType.Inow, 'inow'],
    [DataSourceType.Illuminates, 'illuminates'],
    [DataSourceType.Coursera, 'coursera'],
    [DataSourceType.LTI, 'lti'],
    [DataSourceType.Gg4lPassport, 'gg4lpassport'],
    [DataSourceType.Veracross, 'veracross'],
    [DataSourceType.LDAP, 'ldap'],
    [DataSourceType.GSuite, 'gsuite'],
    [DataSourceType.OpenApply, 'open-apply'],
    [DataSourceType.ManageBac, 'manage-bac'],
    [DataSourceType.Qwiklabs, 'qwiklabs'],
    [DataSourceType.GoogleClassroom, 'google-classroom'],
    [DataSourceType.Aeries, 'aeries'],
    [DataSourceType.Blackboard, 'blackboard'],
]);

export const DataSourceTypeTitleMap = new Map([
    [DataSourceType.DataAPI, 'DataAPI'],
    [DataSourceType.EdFi, 'EdFi'],
    [DataSourceType.EduTone, environment.customer.customerShortName],
    [DataSourceType.OneRoster, 'OneRoster'],
    [DataSourceType.PowerSchool, 'PowerSchool'],
    [DataSourceType.Skyward, 'Skyward'],
    [DataSourceType.SFTP, 'SFTP'],
    [DataSourceType.CsvUpload, 'CsvUpload'],
    [DataSourceType.Inow, 'Inow'],
    [DataSourceType.Illuminates, 'Illuminate'],
    [DataSourceType.Coursera, 'Coursera'],
    [DataSourceType.LTI, 'LTI'],
    [DataSourceType.Gg4lPassport, 'LMS Import'],
    [DataSourceType.Veracross, 'Veracross'],
    [DataSourceType.LDAP, 'Active Directory'],
    [DataSourceType.GSuite, 'G Suite'],
    [DataSourceType.OpenApply, 'OpenApply'],
    [DataSourceType.ManageBac, 'ManageBac'],
    [DataSourceType.Qwiklabs, 'Qwiklabs'],
    [DataSourceType.GoogleClassroom, 'Google Classroom'],
    [DataSourceType.Aeries, 'Aeries'],
    [DataSourceType.Blackboard, 'Blackboard Learn'],
]);

export enum DataSourceFriendlyName {
    'GG4L Data API' = 'Data API',
    'Data API' = 'Data API',
    EdFi = 'EdFi',
    Passport = 'Passport',
    OneRoster = 'OneRoster',
    PowerSchool = 'PowerSchool',
    'PowerSchool (OneRoster)' = 'PowerSchool (OneRoster)',
    SFTP = 'SFTP',
    Skyward = 'Skyward',
    'CSV Upload' = 'CSV Upload',
    'Skyward (OneRoster)' = 'Skyward (OneRoster)',
    Aeries = 'Aeries',
    'Aeries (OneRoster)' = 'Aeries (OneRoster)',
    'Follett Aspen' = 'Follett Aspen',
    'eSchoolPlus' = 'eSchoolPlus',
    Focus = 'Focus',
    'Infinite Campus' = 'Infinite Campus',
    Inow = 'iNOW',
    Illuminate = 'Illuminate',
    FACTS = 'FACTS',
    Coursera = 'Coursera',
    'Blackboard Export' = 'Blackboard Export',
    'Blackboard Import' = 'Blackboard Import',
    Blackboard = 'Blackboard Learn',
    'Canvas Export' = 'Canvas Export',
    'Canvas Import' = 'Canvas Import',
    'Moodle Export' = 'Moodle Export',
    'Moodle Import' = 'Moodle Import',
    'LMS Import' = 'LMS Import',
    Veracross = 'Veracross',
    'AWS S3' = 'AWS S3',
    'Lumen Touch' = 'Lumen Touch',
    LDAP = 'Active Directory',
    GSuite = 'Google Workspace',
    'Google Workspace IDM' = 'Google Workspace IDM',
    OpenApply = 'OpenApply',
    ManageBac = 'ManageBac',
    Sapphire = 'Sapphire',
    Synergy = 'Synergy',
    Blackbaud = 'Blackbaud',
    ClassLink = 'ClassLink',
    Clever = 'Clever',
    Qwiklabs = 'Qwiklabs',
    GoogleClassroom = 'Google Classroom',
    Edsembli = 'Edsembli',
    MichiganDataHub = 'MichiganDataHub',
    SchoolTool = 'SchoolTool',
    Aspire = 'Aspire'
}

export const DataSourceWithoutFiltersList = [DataSourceType.Passport];

export const DataSourceHiddenInAppGallery = [DataSourceType.Qwiklabs];
export const ALLOWED_ONLY_ONE_APPLICATION_LIST = [DataSourceType.Coursera/*, DataSourceType.Qwiklabs*/];

export function isFiltersAllowedForDataSource(dataSourceType: DataSourceType): boolean {
    return DataSourceWithoutFiltersList.every((item: string) => <string>item !== <string>dataSourceType);
}

export const RESTRICTED_INCREMENTAL_SYNC_DATA_SOURCE_LIST: DataSourceType[] = [
    DataSourceType.CsvUpload,
    DataSourceType.DataAPI,
    DataSourceType.EdFi,
    DataSourceType.OneRoster,
    DataSourceType.PowerSchool,
    DataSourceType.SFTP,
    DataSourceType.Skyward,
    DataSourceType.Inow,
    DataSourceType.Illuminates,
    DataSourceType.Coursera,
    DataSourceType.LTI,
    DataSourceType.Gg4lPassport,
    DataSourceType.Passport,
    DataSourceType.Veracross,
    DataSourceType.LDAP,
    DataSourceType.GSuite,
    DataSourceType.Qwiklabs,
    DataSourceType.GoogleClassroom,
    DataSourceType.Aeries,
    DataSourceType.Blackboard,
];

export const ALLOWED_INCREMENTAL_SYNC_DATA_SOURCE_LIST = [
    DataSourceType.OpenApply,
    DataSourceType.ManageBac
];

export function isIncrementalSyncAllowed(
    dataSourceType?: DataSourceType,
    mode?: IntegrationMode,
    defaultSchemaName?: DefaultSchemaName,
    isSupportIncrementalSyncFeatureToggleIsActive: boolean = false
): boolean {
    return (dataSourceType && (RESTRICTED_INCREMENTAL_SYNC_DATA_SOURCE_LIST.indexOf(dataSourceType) === -1))
        || (ALLOWED_INCREMENTAL_SYNC_DATA_SOURCE_LIST.indexOf(dataSourceType) > -1)
        || ((dataSourceType === DataSourceType.SFTP)
            && (mode === IntegrationMode.EXPORT)
            && ((defaultSchemaName === DefaultSchemaName.AMPLIFY) || (defaultSchemaName === DefaultSchemaName.SCHOOL_TUBE)))
        || isSupportIncrementalSyncFeatureToggleIsActive;
}

export const RESTRICTED_SYNC_DATA_SOURCE_LIST = [
    DataSourceType.DataAPI,
    DataSourceType.Passport
];

export function isRunSyncSyncAllowed(dataSourceType: DataSourceType, mode: IntegrationMode, dataSourceConfig: DataSourceConfig = null): boolean {
    return (RESTRICTED_SYNC_DATA_SOURCE_LIST.indexOf(dataSourceType) === -1)
        && ((dataSourceType !== DataSourceType.SFTP) || (mode === IntegrationMode.EXPORT) || !dataSourceConfig || !dataSourceConfig.isManuallyUpload);
}

export const DATASOURCE_INFO: IDataSourceInfo[] = [
    {dataSourceType: 'Illuminates', name: 'Illuminate', icon: 'assets/images/logos/datasources/illuminate.png', dname: '', guid: ''},
    {dataSourceType: 'Inow', name: 'InformationNOW', icon: 'assets/images/logos/datasources/inow.png', dname: '', guid: ''},
    {dataSourceType: 'OneRoster', name: 'OneRoster', icon: 'assets/images/logos/datasources/oneroster.png', dname: '', guid: ''},
    {dataSourceType: 'PowerSchool', name: 'PowerSchool', icon: 'assets/images/logos/datasources/ps.png', dname: '', guid: ''},
    {dataSourceType: 'SFTP', name: 'SFTP', icon: 'assets/images/logos/datasources/sftp.png', dname: '', guid: ''},
    {dataSourceType: 'Skyward', name: 'Skyward', icon: 'assets/images/logos/datasources/skyward.png', dname: '', guid: ''},
    {dataSourceType: 'Coursera', name: 'Coursera', icon: 'assets/images/logos/datasources/coursera.png', dname: '', guid: ''},
    {dataSourceType: 'LTI', name: 'LTI', icon: 'assets/images/logos/datasources/lti.png', dname: '', guid: ''},
    {dataSourceType: 'Gg4lPassport', name: 'LMS Import', icon: 'assets/images/logos/datasources/lmsimport.png', dname: '', guid: ''},
    {dataSourceType: 'Veracross', name: 'Veracross', icon: 'assets/images/logos/datasources/veracross.png', dname: '', guid: ''},
    {dataSourceType: 'OpenApply', name: 'OpenApply', icon: 'assets/images/logos/datasources/oa.png', dname: '', guid: ''},
    {dataSourceType: 'ManageBac', name: 'ManageBac', icon: 'assets/images/logos/datasources/mb.png', dname: '', guid: ''},
    {dataSourceType: 'Qwiklabs', name: 'Qwiklabs', icon: 'assets/images/logos/datasources/qwiklabs.png', dname: '', guid: ''},
    {dataSourceType: 'GoogleClassroom', name: 'Google Classroom', icon: 'assets/images/logos/datasources/gclassroom.png', dname: '', guid: ''},
    {dataSourceType: 'Aeries', name: 'Aeries', icon: 'assets/images/logos/datasources/aeries.png', dname: '', guid: ''},
    {dataSourceType: 'GSuite', name: 'GSuite', icon: 'assets/images/logos/datasources/gsuite.png', dname: '', guid: ''},
    {dataSourceType: 'Blackboard', name: 'Blackboard Learn ', icon: 'assets/images/logos/datasources/blackboard_learn.png', dname: '', guid: ''}
];

export const SupportMappingRulesDataSourceTypes = [DataSourceType.LDAP, DataSourceType.GSuite];
export const SupportGradeMappingDataSourceTypes = [DataSourceType.ManageBac, DataSourceType.OpenApply];
export const SupportAmplifyStaffAccessMappingDataSourceTypes = [DataSourceType.SFTP];

export const SisIdMap = new Map<DataSourceType | DataSourceFriendlyName | string, {key: string; title: string; value?: string; icon?: string}>([
    ['Azure AD', {key: 'mic_id', title: 'Azure AD' }],
    ['Canvas', {key: 'canv_id', title: 'Canvas', value: '', icon: 'assets/images/logos/datasources/canvas.png' }],
    ['G Suite', {key: 'google_id', title: 'G Suite', value: '', icon: 'assets/images/logos/datasources/gsuite.png'}],
    ['Google Classroom', {key: 'google_classroom_id', title: 'Google Classroom', value: '', icon: 'assets/images/logos/datasources/gclassroom.png'}],
    [DataSourceType.Illuminates, {key: 'ill_id', title: 'Illuminate', value: '', icon: 'assets/images/logos/datasources/illuminate.png'}],
    ['Inow', {key: 'inow_id', title: 'InformationNOW', value: '', icon: 'assets/images/logos/datasources/inow.png'}],
    ['LAUSD', {key: 'lausd_id', title: 'LAUSD'}],
    [DataSourceType.LDAP, {key: 'ldap_id', title: 'Active Directory', value: '', icon: 'assets/images/logos/datasources/ldap.png'}],
    ['Microsoft SDS', {key: 'ms_sds_id', title: 'Microsoft SDS', value: '', icon: 'assets/images/logos/datasources/mssds.png'}],
    ['ManageBac', {key: 'mb_id', title: 'ManageBac', value: '', icon: 'assets/images/logos/datasources/mb.png'}],
    ['OpenApply', {key: 'oa_id', title: 'OpenApply', value: '', icon: 'assets/images/logos/datasources/oa.png'}],
    [DataSourceType.OneRoster, {key: 'or_id', title: 'OneRoster', value: '', icon: 'assets/images/logos/datasources/oneroster.png'}],
    [DataSourceType.PowerSchool, {key: 'ps_id', title: 'PowerSchool', value: '', icon: 'assets/images/logos/datasources/ps.png'}],
    ['PowerSchool DCID', {key: 'ps_dcid', title: 'PS DCID', value: '', icon: ''}],
    [DataSourceType.SFTP, {key: 'sftp_id', title: 'SFTP', value: '', icon: 'assets/images/logos/datasources/sftp.png'}],
    [DataSourceType.Skyward, {key: 'sw_id', title: 'Skyward', value: '', icon: 'assets/images/logos/datasources/skyward.png'}],
    ['Application Credentials', {key: 'uac_id', title: 'Application Credentials'}],
    ['xPress Roster', {key: 'xpr_id', title: 'xPress Roster', value: '', icon: 'assets/images/logos/datasources/xpress.png'}],
    ['Coursera', {key: 'coursera_id', title: 'Coursera', value: '', icon: 'assets/images/logos/datasources/coursera.png'}],
    [DataSourceType.LTI, {key: 'lti_id', title: 'LTI', value: '', icon: 'assets/images/logos/datasources/lti.png'}],
    [DataSourceType.Veracross, {key: 'veracross_id', title: 'Veracross', value: '', icon: 'assets/images/logos/datasources/veracross.png'}],
    [DataSourceType.Qwiklabs, {key: 'qwiklabs_id', title: 'Qwiklabs', value: '', icon: 'assets/images/logos/datasources/qwiklabs.png'}],
    [DataSourceType.Aeries, {key: 'aeries_id', title: 'Aeries', value: '', icon: 'assets/images/logos/datasources/aeries.png'}],
    [DataSourceType.Blackboard, {key: 'blackboard_id', title: 'Blackboard Learn', value: '', icon: 'assets/images/logos/datasources/blackboard_learn.png'}]
]);

export const OrgTypeSupportedDataSources = [DataSourceType.LDAP, DataSourceType.GSuite];

export const DEFAULT_APPS_NAME_SORT_ORDER = {
    [DataSourceFriendlyName.PowerSchool]: 1,
    [DataSourceFriendlyName['PowerSchool (OneRoster)']]: 2,
    [DataSourceFriendlyName.SFTP]: 3,
    [DataSourceFriendlyName.Skyward]: 4,
    [DataSourceFriendlyName['Skyward (OneRoster)']]: 5,
    [DataSourceFriendlyName['Infinite Campus']]: 6,
    [DataSourceFriendlyName.OneRoster]: 7,
    [DataSourceFriendlyName['Aeries Native API']]: 8,
    [DataSourceFriendlyName['Aeries (OneRoster)']]: 9,
    [DataSourceFriendlyName['Follett Aspen']]: 10,
    [DataSourceFriendlyName['eSchoolPlus']]: 11,
    [DataSourceFriendlyName.Inow]: 12,
    [DataSourceFriendlyName.FACTS]: 13,
    [DataSourceFriendlyName.ClassLink]: 14,
    [DataSourceFriendlyName.Focus]: 15,
    [DataSourceFriendlyName.Blackbaud]: 16,
    [DataSourceFriendlyName.Veracross]: 17,
    [DataSourceFriendlyName.Qwiklabs]: 18,
    [DataSourceFriendlyName.Sapphire]: 19,
    'Schoology Import': 20,
    'Schoology Export': 21,
    [DataSourceFriendlyName.Illuminate]: 22,
    [DataSourceFriendlyName.LDAP]: 23,
    [DataSourceFriendlyName.GoogleClassroom]: 24,
    [DataSourceFriendlyName['Lumen Touch']]: 25,
    [DataSourceFriendlyName['MichiganDataHub']]: 26,
    [DataSourceFriendlyName['Moodle Import']]: 27,
    [DataSourceFriendlyName['Moodle Export']]: 28,
    [DataSourceFriendlyName.Clever]: 29,
    [DataSourceFriendlyName.Coursera]: 30,
    'Desire2Learn Import': 31,
    'Desire2Learn Export': 32,
    [DataSourceFriendlyName['Blackboard']]: 33,
    [DataSourceFriendlyName['Blackboard Import']]: 34,
    [DataSourceFriendlyName['Blackboard Export']]: 35,
    [DataSourceFriendlyName['Canvas Import']]: 36,
    [DataSourceFriendlyName['Canvas Export']]: 37,
    [DataSourceFriendlyName['CSV Upload']]: 38,
    [DataSourceFriendlyName['Edsembli']]: 39
    // [DataSourceFriendlyName.OpenApply]: 'open-apply', ?????????
    // [DataSourceFriendlyName.ManageBac]: 'manage-bac', ?????????
};

export const SOURCE_ATTRIBUTE_IS_ALLOWED_TO_MAP_IN_MULTIPLE_TASKS = [
    DataSourceType.GSuite
];

export const RunPreviewAllowedApplications = new Map<string, IntegrationMode[]>([
    [DataSourceFriendlyName.GSuite, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Google Workspace IDM'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.Blackboard, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.PowerSchool, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.Skyward, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Infinite Campus'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Skyward (OneRoster)'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Aeries (OneRoster)'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Lumen Touch'], [IntegrationMode.SYNC]]
]);

export const PreviewOnFirstRunApplications = new Map<string, IntegrationMode[]>([
    [DataSourceFriendlyName.GSuite, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Google Workspace IDM'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.Blackboard, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.PowerSchool, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.Skyward, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Infinite Campus'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Skyward (OneRoster)'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Aeries (OneRoster)'], [IntegrationMode.SYNC]]
]);

export const EnterpriseEditionApplications = new Map<string, IntegrationMode[]>([
    [DataSourceFriendlyName.GSuite, [IntegrationMode.SYNC]],
    [DataSourceFriendlyName['Google Workspace IDM'], [IntegrationMode.SYNC]],
    [DataSourceFriendlyName.Blackboard, [IntegrationMode.IMPORT, IntegrationMode.SYNC]]
]);

const ROSTER_IMPORT_GRADEBOOK_SYNC_DESCRIPTION = new Map<IntegrationMode, string[]>([
    [IntegrationMode.IMPORT, ['Roster data']],
    [IntegrationMode.SYNC, ['Roster data import', 'Gradebook 2-way sync']]
]);

export const INTEGRATION_MODE_LIMITATIONS_DESCRIPTIONS = new Map<string, Map<IntegrationMode, string[]>>([
    [DataSourceFriendlyName.PowerSchool, ROSTER_IMPORT_GRADEBOOK_SYNC_DESCRIPTION],
    [DataSourceFriendlyName.Skyward, ROSTER_IMPORT_GRADEBOOK_SYNC_DESCRIPTION],
    [DataSourceFriendlyName['Infinite Campus'], ROSTER_IMPORT_GRADEBOOK_SYNC_DESCRIPTION],
    [DataSourceFriendlyName['Skyward (OneRoster)'], ROSTER_IMPORT_GRADEBOOK_SYNC_DESCRIPTION],
    [DataSourceFriendlyName['Aeries (OneRoster)'], ROSTER_IMPORT_GRADEBOOK_SYNC_DESCRIPTION]
]);

export const ApplicationsWithTreeOrgsMappingViewActive = [DATA_SOURCE_TYPE.Blackboard];
